import React from 'react'

export default function SubGradeInput({inputname, lesson, setLesson, grade, setGrade}) {
    //console.log("inputname",inputname);
  return (
    <div className="d-flex gap-1">
      <div className='col-8'>
    <input
      type="text"
      name={inputname}
      value={lesson}      
      onChange={(e) => setLesson(e.target.value)}
      className="form-control form-control-sm m-1 border border-secondary"
     // style={{minWidth:"60px", maxWidth:"170px"}}
      placeholder="-"
    />
    </div>
    <div className='col-4'>
    <input
      type="number"
      name="note1"
      value={grade}
     onChange={(e) => setGrade(e.target.value)}
      className="form-control form-control-sm m-1 border border-secondary"
      //style={{minWidth:"20px", maxWidth:"100px"}}
      placeholder="0"
    />
     </div>
  </div>
 )
}
